import React, {useState} from 'react';
import "../css/reportLocation.css";
import {BASE_URL} from "../constants";
import { useLanguage } from "../components/Language.js";

function LocationReportForm({ locationName, onClose }) {

    const [reportTitle, setReportTitle] = useState("");
    const [reportReason, setReportReason] = useState("");

    const {language} = useLanguage();

    const translations = {
        en: {
            hereToReport: `You are here to report ${locationName}`,
            title: "Title",
            reportReason: "Please provide a reason for reporting this location.",
            sendReport: "Send Report",
            close: "Close",
               
        },

        gd: {
            hereToReport: `Tha thu an seo gus aithris air ${locationName}`,
            title: "Tiotal",
            reportReason: "Thoir seachad adhbhar airson an tachartais seo aithris, mas e do thoil e ... ",
            sendReport: "Cuir air falbh an aithisg",
            close: "Dùin",
        },
    };

    const handleSubmit = async () => {
        
        const response = await fetch(`${BASE_URL}/api/save_location_report/`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                "reported_location_name": locationName,
                "report_title": reportTitle,
                "report_content": reportReason}),

        }
        
        )
    };

    return(

        <div className="report-location">
        <h2>{translations[language].hereToReport}</h2>
        <form onSubmit={handleSubmit}>
            <input
                required
                type="text"
                id="title"
                placeholder={translations[language].title}
                value={reportTitle}
                className="user-report-input-box-long"
                onChange={(e) => setReportTitle(e.target.value)}
            />
            
            <textarea
                required
                value={reportReason}
                onChange={(e) => setReportReason(e.target.value)}
                placeholder={translations[language].reportReason}
                rows="4"
                cols="50"
            ></textarea>
            <br />

            <button type="submit">{translations[language].sendReport}</button>
            <button onClick={onClose}>{translations[language].close}</button>
        </form>
    </div>

    );
}

export default LocationReportForm;